// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__3y-cg","gfeWrapper":"CalendarEvent_gfeWrapper__1PCPC"};